import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { ServiceOptionsExplainedDrawer } from './options-explained-drawer.component'

export interface ServiceOptionsExplainedDrawerContextProps {
  showServiceOptionsExplainedDrawer: boolean
  setShowServiceOptionsExplainedDrawer: Dispatch<SetStateAction<boolean>>
  isEv: boolean
  setIsEv: Dispatch<SetStateAction<boolean>>
}

export const ServiceOptionsExplainedDrawerContext =
  createContext<ServiceOptionsExplainedDrawerContextProps>({
    showServiceOptionsExplainedDrawer: false,
    setShowServiceOptionsExplainedDrawer: () => null,
    isEv: false,
    setIsEv: () => null,
  })

export const useServiceOptionsExplainedDrawer = () =>
  useContext(ServiceOptionsExplainedDrawerContext)

interface ServiceOptionsExplainedDrawerProviderProps {
  children: React.ReactNode
}

const ServiceOptionsExplainedDrawerProvider: React.FC<
  ServiceOptionsExplainedDrawerProviderProps
> = ({ children }) => {
  const [
    showServiceOptionsExplainedDrawer,
    setShowServiceOptionsExplainedDrawer,
  ] = useState<boolean>(false)
  const [isEv, setIsEv] = useState<boolean>(false)
  return (
    <ServiceOptionsExplainedDrawerContext.Provider
      value={{
        showServiceOptionsExplainedDrawer,
        setShowServiceOptionsExplainedDrawer,
        isEv,
        setIsEv,
      }}
    >
      <ServiceOptionsExplainedDrawer />
      {children}
    </ServiceOptionsExplainedDrawerContext.Provider>
  )
}

export { ServiceOptionsExplainedDrawerProvider }
